import React from 'react';

/**
 * GetSpark official logo — clean GS monogram + GETSPARK wordmark on transparent BG.
 *
 * Variants:
 *  - "full" (default): GS symbol + GETSPARK wordmark stacked vertically. Use in hero / login / signup.
 *  - "symbol": only the GS monogram (square). Use in compact AppShell, mobile nav, favicons.
 *
 * Props:
 *  - height: pixel height (width auto-scales via aspect ratio)
 *  - variant: 'full' | 'symbol'
 *  - className: extra wrapper classes
 *  - alt: accessibility label
 *
 * Aspect ratios:
 *  - full: 1303 / 657 ≈ 1.98
 *  - symbol: 1:1 (square)
 */
const SparkLogo = ({ height = 56, variant = 'full', className = '', alt = 'GetSpark' }) => {
  const src = variant === 'symbol' ? '/assets/symbol-gs.png' : '/assets/logo-getspark.png';
  return (
    <img
      src={src}
      alt={alt}
      draggable={false}
      decoding="async"
      fetchpriority="high"
      className={`block select-none ${className}`}
      style={{
        height: `${height}px`,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        objectPosition: 'left center',
        imageRendering: '-webkit-optimize-contrast',
      }}
    />
  );
};

export default SparkLogo;
